(function(){
  var d=document,h=d.documentElement;
  function done(){
    if(h.classList.contains('ce-pdp-done'))return;
    h.classList.add('ce-pdp-done');
    h.classList.remove('ce-pdp-wait');
  }
  function reveal(){
    if(window.requestAnimationFrame){requestAnimationFrame(function(){requestAnimationFrame(done)})}else{done()}
  }
  var now=(window.performance&&performance.now)?performance.now():0;
  setTimeout(done,Math.max(0,1200-now));
  setTimeout(function(){if(d.body)d.body.classList.add('ce-up-noreserve')},4500);
  if(!d.fonts||!d.fonts.load){done();return}
  function go(){
    var f=['700 1em Montserrat','400 1em Rubik','700 1em Rubik','400 1em Inter','500 1em Inter'];
    var p=f.map(function(x){return d.fonts.load(x).catch(function(){})});
    Promise.all(p).then(function(){return d.fonts.ready}).then(reveal,reveal);
  }
  if(d.readyState==='loading'){d.addEventListener('DOMContentLoaded',go)}else{go()}
})();
